import getRequest from '@helpers/api/get';
import putRequest from '@helpers/api/put';

/**
 * @typedef {Object} BankingDetails
 * @property {string} bank_name - Name of Bank
 * @property {string} bank_address - Address of Bank
 * @property {string} swift - SWIFT code
 * @property {string} iban - IBAN code
 * @property {string} account_number - IBAN code
 * @property {string} reference - Reference
 */

/**
 * @typedef {Object} Payload
 * @property {string} id - Registration id
 * @property {BankingDetails} data - Registration Banking details.
 */

/**
 *
 * @param {Payload} payload
 * @returns {Promise<*|BankingDetails>}
 */
export const setBankingDetails = payload =>
  putRequest(`vFlow/vatNumber/${payload.regId}/bankDetails/`, payload.data);

/**
 * Gets banking details for a single registration
 * @param {string} id - Registration id
 * @returns {Promise<*|BankingDetails>}
 */
export const getBankingDetails = id => getRequest(`vFlow/vatNumber/${id}/bankDetails/`);
